var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    _vm._b(
      {
        attrs: {
          "max-width": "750px",
          persistent: "",
          "disable-close": _vm.loading,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("\n    Add Alias\n  ")]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("MonitoringFeatureAlias.aliasCanContainDataMsg")
                      ) +
                      "\n    "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "v-form",
                  {
                    ref: "form",
                    model: {
                      value: _vm.formIsValid,
                      callback: function ($$v) {
                        _vm.formIsValid = $$v
                      },
                      expression: "formIsValid",
                    },
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        required: "",
                        label: "Alias name",
                        rules: _vm.synonymNameFormField.rules,
                      },
                      model: {
                        value: _vm.synonymNameFormField.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.synonymNameFormField, "value", $$v)
                        },
                        expression: "synonymNameFormField.value",
                      },
                    }),
                    _vm._v(" "),
                    _vm.isSystemAdmin
                      ? [
                          _c("v-subheader", { staticClass: "pl-0" }, [
                            _vm._v("System Administrator Settings"),
                          ]),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: {
                              color: "info",
                              label: "Make primary alias",
                              "persistent-hint": "",
                              hint: "The primary alias is the name used in reports",
                            },
                            model: {
                              value: _vm.formIsPrimary,
                              callback: function ($$v) {
                                _vm.formIsPrimary = $$v
                              },
                              expression: "formIsPrimary",
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "v-alert",
                  {
                    key: "alert",
                    staticClass: "my-0",
                    attrs: {
                      outline: "",
                      type: "warning",
                      value: _vm.formIsPrimary,
                    },
                  },
                  [
                    _c("div", { staticClass: "primary--text" }, [
                      _vm._v(
                        "\n        The primary alias name shows up in reports, which may cause confusion when the primary alias does not match\n        the location name.\n      "
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      loading: _vm.loading,
                      disabled: !_vm.formIsValid,
                    },
                    on: { click: _vm.submit },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(" " + _vm._s(_vm.$t("Button.Save")) + "\n    "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      outline: "",
                      color: "secondary",
                      disabled: _vm.loading,
                    },
                    on: { click: _vm.close },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      },
      "AppModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }